<template>
  <footer class="footer-wrap" style="height: 85px">
    <div class="marquee">
      <div class="marquee-content">点金服务热线:18927400408</div>
    </div>
    <el-row class="full-height">
      <el-col
        v-for="(tab, index) in GLOBAL.tabs"
        :key="index"
        :span="5"
        class="active-tab"
        @click.native="handleSelectTabIn(index, tab.name)"
      >
        <img
          :src="tab.selected ? tab.selectedImage : tab.defaultImage"
          alt=""
          class="tab-icon"
        >
        <div :style="{ color: tab.selected ? 'rgb(56, 187, 247)' : 'white' }">{{ tab.name }}</div>
      </el-col>
    </el-row>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
    }
  },
  methods: {
    handleSelectTabIn (index, tabName) {
      this.handleSelectTab(index, tabName)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue